export default __webpack_public_path__ + "static/media/HeroLight.86fc412a.svg";